<template>
  <button class="share" @click.stop="copyLink">
    <img src="/share-icon.svg" alt="Share" loading="lazy" />
  </button>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";

export default {
  name: "ShareBtn",
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notification: useNotificationStore(),
    };
  },
  methods: {
    async copyLink() {
      if (this.$route.fullPath === "/") {
        await navigator.clipboard.writeText(
          import.meta.env.VITE_BASE_URL + "/post/" + this.post.id,
        );
      } else {
        await navigator.clipboard.writeText(
          import.meta.env.VITE_BASE_URL + this.$route.fullPath,
        );
      }

      this.notification.show(this.$t("notification.copy"));
    },
  },
};
</script>

<style>
.share {
  background: none;
  border: none;
  margin-left: auto;
  cursor: pointer;
  border-radius: 50%;
  transition: all var(--transition-time) ease;
  height: 20px;
}

.share:hover {
  opacity: 0.5;
}

.share img:active {
  transition: all var(--transition-time) ease;
  transform: scale(0.8);
}
</style>
